import OktaVue from '@okta/okta-vue';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import Toaster from "@meforma/vue-toaster";
import router from './router';
import errorHandling from '@/shared/errorHandling';
import { oktaAuth } from './shared/auth'; 

createApp(App)
    .use(router)
    .use(OktaVue, { oktaAuth })
    .use(createPinia())
    .use(Toaster, {
        position: 'top-right',
        duration: 1000
    })
    .mixin(errorHandling)
.mount('#app');
